type Props = {
  current: number
  total: number
}

export const ImageCountIndicator: React.FC<Props> = ({ current, total }) => (
  <div className="flex space-x-[5px]">
    {[...Array(total)].map((_, i) => (
      <div
        key={i}
        className={`size-[6px] rounded-full bg-white ${
          i !== current - 1 ? 'opacity-50' : ''
        }`}
      />
    ))}
  </div>
)
